import { createSlice } from '@reduxjs/toolkit'
import { NO } from '../../constants/roadwayVariables'

const initialState = {
  roadway_name: '',
  street_width: '',
  roadway_name_notes: '',
  avg_daily_traffic: '<5000',
  avg_daily_traffic_notes: '',
  prevailing_posted_speed: 10,
  prevailing_posted_speed_notes: '',
  raised_median: '',
  raised_median_notes: '',
  travel_lanes: 1,
  travel_lanes_notes: '',
  land_use_context: '',
  land_use_context_notes: '',
  high_capacity_transit: NO,
  high_capacity_transit_notes: ''
}

const roadwayVariables = createSlice({
  name: 'roadwayVariables',
  initialState,
  reducers: {
    setRoadwayVariables(state, action) {
      const { field, value } = action.payload
      state[field] = value
    },
    resetRoadwayVariables(state) {
      return initialState
    },
    setAllRoadwayVariables(state, action) {
      return action.payload
    }
  }
})

export const {
  setRoadwayVariables,
  resetRoadwayVariables,
  setAllRoadwayVariables
} = roadwayVariables.actions
export default roadwayVariables.reducer
